import { Tooltip } from 'antd';
import React from 'react'
import { amtReg, amtRegMessage, goodQQEmailReg } from './regConstants'
const execStyle = { color: 'red' };
// import { useSelector } from 'react-redux'
// const langValue = useSelector(state=>state.langList.value)
export const addBillCols = [
    {
        title: '开立日',
        en_title: 'Issuance date',
        ch_title: '开立日',
        dataIndex: '开立日',
    },
    {
        title: '开立票据名称',
        ch_title: '开立票据名称',
        en_title: 'Receipt Title',
        dataIndex: '开立票据名称',
    },
    {
        title: '身份证号',
        ch_title: '身份证号',
        en_title: 'ID No.',
        dataIndex: '身份证号',
    },
    {
        title: '纳税人识别号',
        en_title: 'TIN',
        ch_title: '纳税人识别号',
        dataIndex: '纳税人识别号',
    },
    {
        title: '金额',
        ch_title: '金额',
        en_title: 'Amount',
        dataIndex: '金额',
    },
    {
        title: '用途',
        ch_title: '用途',
        en_title: 'Purpose',
        dataIndex: '用途',
    },
    {
        title: '备注',
        en_title: 'Remarks',
        ch_title: '备注',
        dataIndex: '备注',
    },
    //
    // {
    //     title: '非陆籍填1',
    //     en_title: 'if Foreign set 1',
    //     ch_title: '非陆籍填1',
    //     dataIndex: '非陆籍填1',
    // },
    // {
    //     title: '法人填1，自然人不填',
    //     en_title: 'if Legal person set 1',
    //     ch_title: '法人填1，自然人不填',
    //     dataIndex: '法人填1，自然人不填',
    // },
    {
        title: '地区',
        en_title: 'Region',
        ch_title: '地区',
        dataIndex: '地区',
    },
    {
        title: '志工编号',
        en_title: 'Commissioner Number',
        ch_title: '志工编号',
        dataIndex: '志工编号',
    },
    {
        title: '志工姓名',
        ch_title: '志工姓名',
        en_title: 'Commissioner Name',
        dataIndex: '志工姓名',
    },
    {
        title: '志工英文名',
        ch_title: '志工英文名',
        en_title: 'Commissioner enName',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '手机号',
        en_title: 'Phone#',
        ch_title: '手机号',
        dataIndex: '手机号',
    },
    {
        title: '地址',
        en_title: 'Address',
        ch_title: '地址',
        dataIndex: '地址',
    },
    {
        title: '邮箱',
        en_title: 'Email',
        ch_title: '邮箱',
        dataIndex: '邮箱',
    }
]

export const billCols = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
        editable: false,
        width: '70px'
    },
    {
        title: '开立票据名称',
        ch_title: '开立票据名称',
        en_title: 'Receipt Title',
        dataIndex: '开立票据名称',
        width: '110px',
        render: (text, record) => {
            let valid = record.billNameValid;
            //字数过长提示
            let reason = record.billNameValidReason;
            // 校验：必填
            return !valid ? (
                <Tooltip title={reason || '必填'} trigger="hover">
                    <div style={execStyle}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        // formItemProps: () => {
        //     return {
        //         rules: [
        //             { required: true, message: '必填' },
        //             { pattern: /^((?![&/\\]).)*$/, message: '不能包含 & / \\ ，请检查！' },
        //         ],
        //     };
        // }
    },
    {
        title: '身份证号',
        ch_title: '身份证号',
        en_title: 'ID No.',
        dataIndex: '身份证号',
        width: '100px',
        render: (text, record) => {
            let valid = record.idcValid;
            // 校验：非必填，小于等于18位
            return !valid ? (
                <Tooltip title='不能超过18位' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        // formItemProps: () => {
        //     return {
        //         rules: [
        //             { pattern: /^\w{0,18}$/, message: '不能超过18位' }
        //         ],
        //     };
        // }
    },
    {
        title: '纳税人识别号',
        en_title: 'TIN',
        ch_title: '纳税人识别号',
        dataIndex: '纳税人识别号',
        width: '110px',
        render: (text, record) => {
            let valid = record.creditNoValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='固定18位，或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        // formItemProps: () => {
        //     return {
        //         rules: [
        //             { pattern: /^\w{18}$/, message: '固定18位，或不填' },
        //         ],
        //     };
        // }
    },
    {
        title: '金额',
        ch_title: '金额',
        en_title: 'Amount',
        dataIndex: '金额',
        width: '80px',
        render: (text, record, index) => {
            let valid = record.amtValid;
            // Tooltip
            return !valid ? (
                <Tooltip title={amtRegMessage} trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                    { pattern: amtReg, message: amtRegMessage }
                ],
            };
        }
    },
    {
        title: '用途',
        ch_title: '用途',
        en_title: 'Purpose',
        dataIndex: '用途',
        width: '8rem',
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '用途必填' },
                ],
            };
        }
    },
    {
        title: '备注',
        en_title: 'Remarks',
        ch_title: '备注',
        dataIndex: '备注',
        width: '90px',
    },
    // @tmpdel
    // {
    //     title: '非陆籍填1',
    //     en_title: 'if Foreign set 1',
    //     ch_title: '非陆籍填1',
    //     dataIndex: '非陆籍填1',
    //     // valueType: 'select',
    //     // valueEnum: {
    //     //     '1': {
    //     //         text: '1',
    //     //     },
    //     //     // 非陆籍
    //     //     '': {
    //     //         text: ' ',
    //     //     },
    //     // },
    //     render: (text, record) => {
    //         let valid = record.outlandValid;
    //         return !valid ? (
    //             <Tooltip title='只能填1或留空' trigger="hover">
    //                 <div style={{ color: 'red' }}>{text}</div>
    //             </Tooltip>)
    //             : (text);
    //     },
    // },
    // {
    //     title: '法人填1，自然人不填',
    //     en_title: 'if Legal person set 1',
    //     ch_title: '法人填1，自然人不填',
    //     dataIndex: '法人填1，自然人不填',
    //     // valueType: 'select',
    //     // valueEnum: {
    //     //     '1': {
    //     //         text: '1',
    //     //     },
    //     //     '': {
    //     //         text: ' ',
    //     //     },
    //     // },
    //     render: (text, record) => {

    //         let valid = record.legalValid;
    //         let requireValid = record.legalRequireValid;
    //         let html;

    //         if (!valid) {
    //             html = (<Tooltip title='只能填1或留空' trigger="hover">
    //                 <div style={{ color: 'red' }}>{text}</div>
    //             </Tooltip>)
    //         } else if (!requireValid) {
    //             html = (<Tooltip title='已填信用代码，必须选法人' trigger="hover">
    //                 <div style={{ color: 'red' }}>{'未填1'}</div>
    //             </Tooltip>)
    //         } else {
    //             html = (text);
    //         }

    //         return html
    //     },
    // },
    {
        title: '志工编号',
        en_title: 'Commissioner Number',
        ch_title: '志工编号',
        dataIndex: '志工编号',
        width: '125px',
        render: (text, record) => {
            let valid = record.volunteerNoValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='必填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '志工编号必填' },
                ],
            };
        }
    },
    {
        title: '志工姓名',
        ch_title: '志工姓名',
        en_title: 'Commissioner Name',
        dataIndex: '志工姓名',
        width: '125px',
        // render: (text, record) => {
        //     let valid = record.volunteerNameValid;
        //     // 校验：必填
        //     return !valid ? (
        //         <Tooltip title='必填' trigger="hover">
        //             <div style={{ color: 'red' }}>
        //                 {text ? text : '未填'}
        //             </div>
        //         </Tooltip>
        //     ) : (text);
        // },
    },
    {
        title: '志工英文名',
        ch_title: '志工英文名',
        en_title: 'Commissioner enName',
        dataIndex: '志工英文名',
        width: '125px',
    },
    {
        title: '手机号',
        en_title: 'Phone#',
        ch_title: '手机号',
        dataIndex: '手机号',
        width: '120px',
        render: (text, record, index) => {
            let valid = record.phoneValid;
            // Tooltip
            return !valid ? (
                <Tooltip title='手机号,1开头的11位数字,或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^1\d{10}$/, message: '手机号,1开头的11位数字,或不填' }
                ],
            };
        }
    },
    {
        title: '地址',
        en_title: 'Address',
        ch_title: '地址',
        dataIndex: '地址',
        width: '100px',
    },
    {
        title: '邮箱',
        en_title: 'Email',
        ch_title: '邮箱',
        dataIndex: '邮箱',
        width: '100px',
        render: (text, record) => {
            let valid = record.emailValid;
            let qqValid = record.emailQQValid;
            // Tooltip
            return !valid ? (
                <Tooltip title='Email须符合邮箱格式或不填' trigger="hover">
                    <div style={{ color: 'origin' }}>
                        {text}
                    </div>
                </Tooltip>
            ) : (
                    qqValid ?
                        text :
                        (<Tooltip title='请检查qq邮箱拼写' trigger="hover">
                            <div style={{ color: 'red' }}>
                                {text}
                            </div>
                        </Tooltip>)
                );
        },
        formItemProps: () => {
            return {
                rules: [
                    //邮箱验证修改
                    { pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, message: 'Email须符合邮箱格式或不填' },
                    { pattern: goodQQEmailReg, message: '请检查qq邮箱拼写' }
                ],
            };
        }
    },
];

export const billCols_qry = [
    {
        title: '序号',
        dataIndex: '序号',
    },
    {
        title: '开立票据名称',
        dataIndex: '开立票据名称',
    },
    {
        title: '身份证号',
        dataIndex: '身份证号',
    },
    {
        title: '纳税人识别号',
        dataIndex: '纳税人识别号',
    },
    {
        title: '金额',
        dataIndex: '金额',
    },
    {
        title: '用途',
        dataIndex: '用途',
    },
    {
        title: '备注',
        dataIndex: '备注',
    },
    // @tmpdel
    // {
    //     title: '非陆籍填1',
    //     dataIndex: '非陆籍填1',
    // },
    // {
    //     title: '法人填1，自然人不填',
    //     dataIndex: '法人填1，自然人不填',
    // },
    {
        title: '志工编号',
        dataIndex: '志工编号',
    },
    {
        title: '志工姓名',
        dataIndex: '志工姓名',
    },
    {
        title: '手机号',
        dataIndex: '手机号',
    },
    {
        title: '地址',
        dataIndex: '地址',
    },
    {
        title: '邮箱',
        dataIndex: '邮箱',
    },
];


export const projRmkCol = {
    title: '项目备注',
    en_title: 'Project Notes',
    ch_title: '项目备注',
    dataIndex: '项目备注',
    // render: (text, record) => {
    //     let valid = record.pmkValid;
    //     // 校验：非必填，小于等于18位
    //     return !valid ? (
    //         <Tooltip title='不能超过100个字' trigger="hover">
    //             <div style={{ color: 'red' }}>
    //                 {text ? text : '未填'}
    //             </div>
    //         </Tooltip>
    //     ) : (text);
    // },
    // formItemProps: () => {
    //     return {
    //         rules: [
    //             { pattern: /^\w{0,100}$/, message: '不能超过100位' }
    //         ],
    //     };
    // },
    sorter: (a, b) => {
        if (a['项目备注']) {
            return a['项目备注'].localeCompare(b['项目备注'])
        }
    }
};


export const validColumn = {
    title: '校验',
    en_title: 'Verification',
    ch_title: '校验',
    dataIndex: 'valid',
    width: '100px',
    // render: (text, record, index) => {
    //     //整行的验证状态
    //     return !record.rcdValid ? <font color='red'>异常</font> : '正常';
    // },
    filters: [
        {
            text: '正常',
            value: true,
        },
        {
            text: '异常',
            value: false,
        },
    ],
    filterMode: 'tree',
    onFilter: (value, record) => {
        console.log(record);
        record['rcdValid'] == value
    },

    // 也可以在col的render控制 
    onCell: (record, rowIndex) => { // 传入两个形参，分别为行内容record与行index
        if (record['cssType']) { // 可根据参数内容进行判断，如果是偶数行，就将背景颜色设置为红色
            return {
                style: {
                    color: 'red', //此处需注意
                },
            };
        }
    },
    editable: false,
};


export const billCols_update = [
    {
        title: '序号',
        en_title: 'S/N',
        ch_title: '序号',
        dataIndex: '序号',
        editable: false,
    },
    {
        title: '开立票据名称',
        ch_title: '开立票据名称',
        en_title: 'Receipt Title',
        dataIndex: '开立票据名称',
        render: (text, record) => {
            let valid = record.billNameValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='必填' trigger="hover">
                    <div style={execStyle}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        // formItemProps: () => {
        //     return {
        //         rules: [
        //             { required: true, message: '必填' },
        //         ],
        //     };
        // }
    },
    {
        title: '身份证号',
        ch_title: '身份证号',
        en_title: 'ID No.',
        dataIndex: '身份证号',
        render: (text, record) => {
            let valid = record.idcValid;
            // 校验：非必填，小于等于18位
            return !valid ? (
                <Tooltip title='不能超过18位' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        // formItemProps: () => {
        //     return {
        //         rules: [
        //             { pattern: /^\w{0,18}$/, message: '不能超过18位' }
        //         ],
        //     };
        // }
    },
    {
        title: '纳税人识别号',
        en_title: 'TIN',
        ch_title: '纳税人识别号',
        dataIndex: 'TIN',
        render: (text, record) => {
            let valid = record.creditNoValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='固定18位,或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        // formItemProps: () => {
        //     return {
        //         rules: [
        //             { pattern: /^\w{18}$/, message: '固定18位,或不填' },
        //         ],
        //     };
        // }
    },
    {
        title: '金额',
        ch_title: '金额',
        en_title: 'Amount',
        dataIndex: '金额',
        render: (text, record, index) => {
            let valid = record.amtValid;
            // Tooltip
            return !valid ? (
                <Tooltip title={amtRegMessage} trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '必填' },
                    { pattern: amtReg, message: amtRegMessage }
                ],
            };
        }
    },
    {
        title: '用途',
        ch_title: '用途',
        en_title: 'Purpose',
        dataIndex: '用途',
        // valueType: 'select',
        width: '6rem',
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '用途必填' },
                ],
            };
        }
    },
    {
        title: '备注',
        en_title: 'Remarks',
        ch_title: '备注',
        dataIndex: '备注',
    },
    // @tmpdel
    // {
    //     title: '非陆籍填1',
    //     en_title: 'if Foreign set 1',
    //     ch_title: '非陆籍填1',
    //     dataIndex: '非陆籍填1',
    //     // valueType: 'select',
    //     // valueEnum: {
    //     //     '1': {
    //     //         text: '1',
    //     //     },
    //     //     // 非陆籍
    //     //     '': {
    //     //         text: ' ',
    //     //     },
    //     // },
    //     render: (text, record) => {
    //         let valid = record.outlandValid;
    //         return !valid ? (
    //             <Tooltip title='只能填1或留空' trigger="hover">
    //                 <div style={{ color: 'red' }}>{text}</div>
    //             </Tooltip>)
    //             : (text);
    //     },
    // },
    // {
    //     title: '法人填1，自然人不填',
    //     en_title: 'if Legal person set 1',
    //     ch_title: '法人填1，自然人不填',
    //     dataIndex: '法人填1，自然人不填',
    //     // valueType: 'select',
    //     // valueEnum: {
    //     //     '1': {
    //     //         text: '1',
    //     //     },
    //     //     '': {
    //     //         text: ' ',
    //     //     },
    //     // },
    //     render: (text, record) => {
    //         let valid = record.legalValid;
    //         let requireValid = record.legalRequireValid;
    //         let html;

    //         if (!valid) {
    //             html = (<Tooltip title='只能填1或留空' trigger="hover">
    //                 <div style={{ color: 'red' }}>{text}</div>
    //             </Tooltip>)
    //         } else if (!requireValid) {
    //             html = (<Tooltip title='已填信用代码，必须选法人' trigger="hover">
    //                 <div style={{ color: 'red' }}>{'未填1'}</div>
    //             </Tooltip>)
    //         } else {
    //             html = (text);
    //         }

    //         return html
    //     },
    // },
    {
        title: '志工编号',
        en_title: 'Commissioner Number',
        ch_title: '志工编号',
        dataIndex: '志工编号',
        render: (text, record) => {
            let valid = record.volunteerNoValid;
            // 校验：必填
            return !valid ? (
                <Tooltip title='必填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text ? text : '未填'}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { required: true, message: '志工编号必填' },
                ],
            };
        }
    },
    {
        title: '志工姓名',
        ch_title: '志工姓名',
        en_title: 'Commissioner Name',
        dataIndex: '志工姓名',
    },
    {
        title: '手机号',
        en_title: 'Phone#',
        ch_title: '手机号',
        dataIndex: '手机号',
        render: (text, record, index) => {
            let valid = record.phoneValid;
            // Tooltip
            return !valid ? (
                <Tooltip title='手机号,1开头的11位数字,或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text}
                    </div>
                </Tooltip>
            ) : (text);
        },
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /^1\d{10}$/, message: '手机号,1开头的11位数字,或不填' }
                ],
            };
        }
    },
    {
        title: '地址',
        en_title: 'Address',
        ch_title: '地址',
        dataIndex: '地址',
    },
    {
        title: '邮箱',
        dataIndex: '邮箱',
        en_title: 'Email',
        ch_title: '邮箱',
        render: (text, record) => {
            let valid = record.emailValid;
            let qqValid = record.emailQQValid;
            // Tooltip
            return !valid ? (
                <Tooltip title='Email须符合邮箱格式或不填' trigger="hover">
                    <div style={{ color: 'red' }}>
                        {text}
                    </div>
                </Tooltip>
            ) : (
                    qqValid ?
                        text :
                        (<Tooltip title='请检查qq邮箱拼写' trigger="hover">
                            <div style={{ color: 'red' }}>
                                {text}
                            </div>
                        </Tooltip>)
                );
        },
        formItemProps: () => {
            return {
                rules: [
                    { pattern: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/, message: 'Email须符合邮箱格式或不填' },
                    { pattern: goodQQEmailReg, message: '请检查qq邮箱拼写' }
                ],
            };
        }
    },
];

//导入提交最大数量 mongodb插入文档 一次最大为16mb 因而限制导入数量
export const MAX_SUBMIT_BILL_NUM = 30000;